(function ($, Promise) {

    // Constructor
    function VICCHome() {
      // console.log("VICCHome: constructor()");

      this.autoScrollTl = gsap.timeline();
      this.trottledScrollFunction = throttle(this.onScroll.bind(this), 200, true);

      // Build threejs powered image canvas
      this.imageCanvases = [];
      for (var i = 0; i < 3; i++) {
        this.imageCanvases.push(new VICCHomeImageCanvas({
          parentSelector: ".home-intro-image:eq(" + i + ")",
          image1: assetPath + '/images/home_image_' + (i + 1) + '_before.jpg',
          image2: assetPath + '/images/home_image_' + (i + 1) + '_after.jpg',
          displacementImage: assetPath + '/images/displacement.png'
        }));
      }

    }

    VICCHome.prototype.attach = function (dom) {
      // console.log("VICCHome: attach()");

      this.prepareDom();
      this.initTrigger();

      for (var i = 0; i < this.imageCanvases.length; i++) {
        this.imageCanvases[i].attach(dom);
      }

      // this.initTween();
      var readyCount = 0;
      $(this.imageCanvases).one("ready", $.proxy(function () {
        readyCount++;
        if (readyCount == this.imageCanvases.length) {
          this.initTween()
        }
      }, this));

      //this.initScrollMagic();
      //this.scrollScene.enabled(true);

      $(window).on('scroll', this.trottledScrollFunction);
      $(window).on("resize", $.proxy(this.resize, this));
    }

    VICCHome.prototype.prepareDom = function () {

    }

    VICCHome.prototype.initTrigger = function () {

      $("#home-intro > .scroll").off("click").on("click", function () {
        VICC.prototype.scrollTo("#home-bottom");
      });

    }

    VICCHome.prototype.initTween = function () {

      if (this.homeTl) {
        this.homeTl.kill();
      }

      this.homeTl = gsap.timeline({
        delay: 0.5,
        callbackScope: this,
        onComplete: function () {
          this.enableFreeMode(true);
        }
      });

      if (window.viewport().width < 768) {
        inView("#main .home-intro-image").on("enter", $.proxy(function (el) {
          if ($(el).hasClass("animated") || $(el).hasClass("animation-done")) {
            return;
          }

          $(el).addClass("animated");

          // Animate
          setTimeout($.proxy(function () {
            this.homeTl.fromTo(this.imageCanvases[$(el).index()], 1.4, {animateValue: 0}, {animateValue: 1});
            this.homeTl.to($("span", el), 1.4, {opacity: 1}, "-=1.4");
          }, this), 1);
        }, this));
      } else {
        $("#main .home-intro-image").each($.proxy(function (i, n) {

          // Animate
          this.homeTl.fromTo(this.imageCanvases[i], 1.4, {animateValue: 0}, {animateValue: 1});
          this.homeTl.to($("span", n), 1.4, {opacity: 1}, "-=1.4");

        }, this));
      }
    }

    /*
     * On scroll callback (throttled)
     */
    VICCHome.prototype.onScroll = function () {
      if ($("#home-bottom")[0].getBoundingClientRect().y - window.viewport().height < -10) {
        $("#home-intro .scroll").addClass("stop");
      } else {
        $("#home-intro .scroll").removeClass("stop");
      }
    }

    VICCHome.prototype.resize = function () {
      for (var i = 0; i < this.imageCanvases.length; i++) {
        this.imageCanvases[i].resize();
      }
    }

    VICCHome.prototype.enableFreeMode = function (value) {
      for (var i = 0; i < this.imageCanvases.length; i++) {
        this.imageCanvases[i].enableFreeMode(value);
      }
    }

    // VICCHome.prototype.initScrollMagic = function () {
    //   this.scrollMagicController = new ScrollMagic.Controller({
    //     refreshInterval: 0
    //   });
    //
    //   this.scrollScene = new ScrollMagic.Scene({
    //     triggerHook: 0,
    //     duration: window.innerHeight * 2,
    //     // duration: $("body").height() - window.innerHeight
    //   });
    //   this.scrollScene.setPin('#home-intro')
    //   this.scrollScene.addTo(this.scrollMagicController);
    //   this.scrollScene.enabled(true);
    // }

    VICCHome.prototype.dettach = function () {
      // console.log("VICCHome: dettach()");

      for (var i = 0; i < this.imageCanvases.length; i++) {
        this.imageCanvases[i].dettach();
      }

      // this.scrollScene.setTween(false);
      // this.scrollScene.enabled(false);
      // this.scrollScene.destroy();
      // this.scrollMagicController.destroy();

      this.homeTl.kill();
      this.autoScrollTl.kill();

      $(this.imageCanvases).off("ready", $.proxy(this.initTween, this));

      $(window).off('scroll', this.trottledScrollFunction);
      $(window).off("resize", $.proxy(this.resize, this));
    }

    // Expose VICCHome
    window.VICCHome = VICCHome;

  }
)
(jQuery, Promise);
